import {createAction} from '@reduxjs/toolkit'
import {
  AssignedPolicyTypes,
  GetPolicyAssigneePayload,
  PoliciesClashesInterface,
  PoliciesClashesPayloadInterface,
  UpdatePolicyAssignmentPayload,
  UserGroupDeleteAction,
} from 'interfaces'

const getPolicyAssignee =
  createAction<GetPolicyAssigneePayload>('getPolicyAssignee')
const getPolicyAssigneeFailure = createAction<string>(
  'getPolicyAssigneeFailure',
)
const getPolicyAssigneeSuccess = createAction<AssignedPolicyTypes[]>(
  'getPolicyAssigneeSuccess',
)

const assignPolicy = createAction<UpdatePolicyAssignmentPayload>('assignPolicy')
const assignPolicyFailure = createAction<string>('assignPolicyFailure')
const assignPolicySuccess = createAction('assignPolicySuccess')

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const changeAssignedPolicy = createAction<any>('changeAssignedPolicy')
const removeAssignedPolicySnapshot = createAction(
  'removeAssignedPolicySnapshot',
)

const setAssignedUsersGroupsToDelete = createAction<UserGroupDeleteAction>(
  'setAssignedUsersGroupsToDelete',
)

const getPolicyClashGroups = createAction<PoliciesClashesPayloadInterface>(
  'getPolicyClashGroups',
)
const getPolicyClashGroupsFailure = createAction<string>(
  'getPolicyClashGroupsFailure',
)
const getPolicyClashGroupsSuccess = createAction<PoliciesClashesInterface>(
  'getPolicyClashGroupsSuccess',
)

const resetPolicyClash = createAction('resetPolicyClash')
const resetPolicyUserList = createAction('resetPolicyUserList')

export {
  getPolicyAssignee,
  getPolicyAssigneeFailure,
  getPolicyAssigneeSuccess,
  assignPolicy,
  assignPolicyFailure,
  assignPolicySuccess,
  changeAssignedPolicy,
  removeAssignedPolicySnapshot,
  setAssignedUsersGroupsToDelete,
  getPolicyClashGroups,
  getPolicyClashGroupsFailure,
  getPolicyClashGroupsSuccess,
  resetPolicyClash,
  resetPolicyUserList,
}
